module.exports = __webpack_public_path__ + "img/empty-search.d3be18a6.png";